import { render, staticRenderFns } from "./CommunityHealthInfoReply.vue?vue&type=template&id=0efa6ae2&"
import script from "./CommunityHealthInfoReply.vue?vue&type=script&lang=js&"
export * from "./CommunityHealthInfoReply.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHealthInfoReply.vue?vue&type=style&index=0&id=0efa6ae2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports